// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart-counter[data-v-403e3132]{background-color:var(--accent-blue);color:#fff;display:flex;justify-content:center;align-items:center;width:20px;height:20px;border-radius:3px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
